var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "container",
      staticClass:
        "z-10 w-full transition-250 transition-height hidden md_block",
      class: [
        _vm.overflowing ? "overflow-auto" : "overflow-hidden",
        _vm.noCollectionImage ? "relative" : "absolute"
      ],
      style: { height: _vm.visible ? _vm.height : 0 }
    },
    [
      _c("div", {
        staticClass:
          "bg-gray-900 opacity-75 absolute h-full w-full top-0 left-0"
      }),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.visible,
              expression: "visible"
            }
          ],
          staticClass:
            "container mx-auto text-gray-400 relative z-1 items-start flex text-sm"
        },
        [
          _c(
            "div",
            {
              staticClass: "w-10-12 flex flex-wrap",
              class: { "justify-between": _vm.collectionLinkCollapsedCount }
            },
            _vm._l(_vm.collections, function(collection, index) {
              return _c(
                "router-link",
                {
                  key: "" + collection.name + collection.slug,
                  ref: "collectionLinks",
                  refInFor: true,
                  staticClass:
                    "px-1 py-1_5 hover_underline cursor-pointer select-none collection-link",
                  attrs: {
                    to: {
                      name: "collection",
                      params: {
                        collectionSlug: collection.slug,
                        publicName: _vm.domainConfig.public_name,
                        page: "1"
                      }
                    }
                  },
                  nativeOn: {
                    keydown: [
                      function($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k($event.keyCode, "tab", 9, $event.key, "Tab")
                        ) {
                          return null
                        }
                        if (
                          $event.ctrlKey ||
                          $event.shiftKey ||
                          $event.altKey ||
                          $event.metaKey
                        ) {
                          return null
                        }
                        return _vm.collectionLinkTabNext($event, index)
                      },
                      function($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k($event.keyCode, "tab", 9, $event.key, "Tab")
                        ) {
                          return null
                        }
                        if (!$event.shiftKey) {
                          return null
                        }
                        if ($event.ctrlKey || $event.altKey || $event.metaKey) {
                          return null
                        }
                        return _vm.collectionLinkTabPrev($event, index)
                      }
                    ]
                  }
                },
                [_vm._v(_vm._s(collection.name))]
              )
            }),
            1
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.displayShowAllToggle,
                  expression: "displayShowAllToggle"
                }
              ],
              staticClass: "w-2-12 flex items-center justify-end"
            },
            [
              _c(
                "a",
                {
                  ref: "seeAll",
                  staticClass:
                    "tracking-wider font-bold leading-none flex items-center px-1 py-1_5 hover_underline cursor-pointer select-none collection-link--see-all",
                  attrs: {
                    tabindex: "0",
                    "aria-expanded": _vm.open ? "true" : "false"
                  },
                  on: {
                    click: _vm.toggleMenu,
                    keyup: function($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      ) {
                        return null
                      }
                      return _vm.toggleMenu($event)
                    },
                    keydown: [
                      function($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k($event.keyCode, "tab", 9, $event.key, "Tab")
                        ) {
                          return null
                        }
                        if (
                          $event.ctrlKey ||
                          $event.shiftKey ||
                          $event.altKey ||
                          $event.metaKey
                        ) {
                          return null
                        }
                        return _vm.seeAllTabNext($event)
                      },
                      function($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k($event.keyCode, "tab", 9, $event.key, "Tab")
                        ) {
                          return null
                        }
                        if (!$event.shiftKey) {
                          return null
                        }
                        if ($event.ctrlKey || $event.altKey || $event.metaKey) {
                          return null
                        }
                        return _vm.seeAllTabPrev($event)
                      }
                    ]
                  }
                },
                [
                  _c("span", [_vm._v("SEE ALL")]),
                  _c(
                    "svg",
                    {
                      staticClass: "h-1 w-1 inline",
                      attrs: { viewBox: "0 0 24 24" }
                    },
                    [
                      _vm.open
                        ? _c("path", {
                            staticClass: "fill-current",
                            attrs: { d: "M19,13H5V11H19V13Z" }
                          })
                        : _c("path", {
                            staticClass: "fill-current",
                            attrs: {
                              d: "M19,13H13V19H11V13H5V11H11V5H13V11H19V13Z"
                            }
                          })
                    ]
                  )
                ]
              )
            ]
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }